import { useState, useEffect } from 'react';
import classNames from 'classnames';
import Sidebar from '../Components/Sidebar/Sidebar';
import Header from '../Components/Header/Header';
import styles from '../assets/scss/MainLayout.module.scss';
import { Outlet } from 'react-router-dom';
import SubHeader from '../Components/Header/SubHeader';
import { getUserInfo } from '../utils/user.util';

const MainLayout = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const toggleSidebar = () => setIsSidebarOpen(!isSidebarOpen);

  return (
    <>
      <div className={styles.mainLayout}>
        <Header />
        {/* <SubHeader /> */}
        <Sidebar isOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />
        <div className={classNames(styles.rightContent, { [styles.fullWidth]: !isSidebarOpen })}>

          <div className={styles.contentArea}>
            <Outlet />
          </div>
        </div>
      </div>
    </>
  );
};

export default MainLayout;

